/** @jsxImportSource @emotion/react */

import { useMutation, useQuery } from '@apollo/client'
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { toast } from 'react-toastify'
import PageTitle from '../../components/PageTitle'
import Seo from '../../components/Seo'
import { useAuthContext } from '../../context/auth.context'
import { ACTIVITY_CORRECTION_REQUEST_DECIDE, GET_ACTIVITY_CORRECTION_REQUESTS, GET_MY_ACTIVITY_CORRECTION_REQUESTS } from '../../graphql/activityCorrectionRequest.graphql'

const CorrectionRequests = () => {
  const { userRole } = useAuthContext()
  const decisionMaker = Number(userRole) >= 4
  const query = decisionMaker ? GET_ACTIVITY_CORRECTION_REQUESTS : GET_MY_ACTIVITY_CORRECTION_REQUESTS
  const requests = useQuery(query).data?.[decisionMaker ? 'getActivityCorrectionRequests' : 'getMyActivityCorrectionRequests'] || []
  const [decide] = useMutation(ACTIVITY_CORRECTION_REQUEST_DECIDE, { refetchQueries: [{ query: GET_ACTIVITY_CORRECTION_REQUESTS }] })
  const handleDecision = async (request, decision) => {
    const decisionReason = window.prompt('Powód decyzji')
    if (!decisionReason) return
    try {
      await decide({ variables: { id: request._id, input: { decision, decisionReason, decisionKey: `correction-decision:${request._id}:${Date.now()}`, expectedVersion: request.version } } })
      toast.success('Decyzja zapisana')
    } catch (error) { toast.error(error.message) }
  }
  return <>
    <Seo title='Correction requests' />
    <PageTitle><h1>Prośby o korektę aktywności</h1></PageTitle>
    <Paper css={panel}><Table size='small'><TableHead><TableRow><TableCell>Status</TableCell><TableCell>Aktywność</TableCell><TableCell>Osoba</TableCell><TableCell>Zmiany</TableCell><TableCell>Powód</TableCell><TableCell>Akcja</TableCell></TableRow></TableHead><TableBody>{requests.map((request) => <TableRow key={request._id}><TableCell>{request.status}</TableCell><TableCell>{request.activity?.title} ({request.activity?.timeStart}–{request.activity?.timeEnd})</TableCell><TableCell>{request.requester?.firstName} {request.requester?.lastName}</TableCell><TableCell><code>{request.changes}</code></TableCell><TableCell>{request.reason}</TableCell><TableCell>{decisionMaker && request.status === 'PENDING' && <><Button onClick={() => handleDecision(request, 'APPROVE')} color='primary'>Akceptuj</Button><Button onClick={() => handleDecision(request, 'REJECT')} color='secondary'>Odrzuć</Button></>}</TableCell></TableRow>)}</TableBody></Table>{requests.length === 0 && <div css={empty}>Brak próśb.</div>}</Paper>
  </>
}

const panel = { marginBottom: '1rem', padding: '1rem', overflowX: 'auto' }
const empty = { padding: '1rem', color: '#666' }

export default CorrectionRequests
